import { render } from "./Icons.vue?vue&type=template&id=46ea36a0&scoped=true"
import script from "./Icons.vue?vue&type=script&lang=js"
export * from "./Icons.vue?vue&type=script&lang=js"

import "./Icons.vue?vue&type=style&index=0&id=46ea36a0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46ea36a0"]])

export default __exports__